<div>
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div>
      <label for="name" translate>app.project.name</label>
      <input type="text" formControlName="name" id="name"
             [ngClass]="{ 'invalid': submitted && fg.name.errors }"/>

      <div *ngIf="submitted && fg.name.errors">
        <div *ngIf="fg.name.errors.required" translate>app.project.name.empty.error</div>
      </div>
    </div>

    <div>
      <label for="description" translate>app.project.description</label>
      <input type="text" formControlName="description" id="description"
             [ngClass]="{ 'invalid': submitted && fg.description.errors }"/>

      <div *ngIf="submitted && fg.description.errors">
        <div *ngIf="fg.description.errors.required" translate>app.project.description.empty.error</div>
      </div>
    </div>

    <button [disabled]="loading" translate>app.project.create.button</button>
    <div *ngIf="error">{{error}}</div>
  </form>
</div>
